import React from 'react';
import PropTypes from 'prop-types';
import { ToolTipPopper } from 'components';

const RadioButton = props => {
  const {
    id,
    labelText,
    name,
    selectedValue,
    selectOptions,
    error,
    handleChange,
    disabled,
    additionalClass,
    toolTipDetails,
  } = props;

  const inputView = selectOptions.map(option => (
    <label key={option.value} className="lf-radio mb-4x" style={{ display: 'flex', paddingLeft: '1.5rem' }}>
      {option.label}
      <input
        type="radio"
        value={option.value}
        checked={selectedValue?.toLowerCase() === option.value}
        onChange={handleChange}
        disabled={disabled}
        name={name}
      />
      {option.toolTipDetails ? (
        <ToolTipPopper placement="top-start" trigger="click" tooltip={option.toolTipDetails} size={14} />
      ) : (
        ''
      )}
      <span className="checkmark"></span>
    </label>
  ));

  return (
    <div className="lf-input-wrap">
      <div className="response__helptext">
        <label htmlFor={id} className={`lf-input__label required ${additionalClass || ''}`}>
          {labelText}
        </label>
        {toolTipDetails ? <ToolTipPopper placement="top-start" trigger="click" tooltip={toolTipDetails} /> : ''}
      </div>
      <div className="response__type row pl-4x">{inputView}</div>
      {error && <p className="lf-input__helper">{error}</p>}
    </div>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  error: PropTypes.any,
  handleChange: PropTypes.any,
  isDisabled: PropTypes.any,
  isMandatory: PropTypes.any,
  label: PropTypes.any,
  name: PropTypes.any,
  selectOptions: PropTypes.any,
  selectedValue: PropTypes.any,
  canReset: PropTypes.bool,
  disabled: PropTypes.bool,
  additionalClass: PropTypes.string,
  toolTipDetails: PropTypes.any,
  isMap: PropTypes.any,
};

export default RadioButton;
